import { Component } from '@angular/core';
import { AppFloatingConfigurator } from "../../../../layout/component/app.floatingconfigurator";

import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select'
import { AvatarModule } from 'primeng/avatar';
import { Menu } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { Popover, PopoverModule } from 'primeng/popover';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/public/services/auth.service';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { CommonService } from 'src/app/private/services/common.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { UserProfileComponent } from "../../../components/user/user-profile/user-profile.component";
import { environment } from 'src/environments/environment';

interface City {
  name: string;
  code: string;
}

interface MenuItem {
  label: string;
  icon?: string;
  items?: MenuItem[];
}

@Component({
  selector: 'app-header',
  imports: [AppFloatingConfigurator, Select, FormsModule, AvatarModule, Menu, BadgeModule, Popover, CommonModule, PopoverModule, SharedModule, UserProfileComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})


export class HeaderComponent {
  campusList: any[] = [];
  userProfileName: string = '';
  showProfile: boolean = false;

  selectedCampus: any;
  items = [
    {
      label: 'Actions',
      items: [

        {
          label: 'Logout',
          icon: 'pi pi-power-off',
          command: () => {
            this.handleLogout();
          }
        }

      ]
    }
  ];

  myStyle = {
      'margin-top': '26px',
      'margin-right': '-100px'
    };

    profilePicture : any = '';

    isProduction: boolean = environment.production;

    environmentName: string = '';

    constructor(private auth: AuthService, private messageService: MessageService, private router: Router,
      private localStorage: LocalStorageService,
      private jwt: JWTTokenServiceService, private api : CommonService
    ) {}

  members = [
      { title: 'Amy Elsner', image: 'amyelsner.png', desc: 'How to write content about your photographs?', time: '42 min ago' },
      { title: 'Bernardo Dominic', image: 'bernardodominic.png', desc: 'Start a blog to reach your creative peak.', time: '1 hr ago' },
      { title: 'Ioni Bowcher', image: 'ionibowcher.png', desc: 'Starting your traveling blog with Vasco.', time: '2 hrs ago' },
      { title: 'Ivan Magalhaes', image: 'ivanmagalhaes.png', desc: 'How to write content about your photographs?', time: '3 hrs ago' },
      { title: 'Brad Joe', image: 'amyelsner.png', desc: 'Start a blog to reach your creative peak.', time: '4 hrs ago' },
      { title: 'Alison Perez', image: 'bernardodominic.png', desc: 'Starting your traveling blog with Vasco.', time: '5 hrs ago' },
      { title: 'Barry Mass', image: 'ionibowcher.png', desc: 'How to write content about your photographs?', time: '6 hrs ago' }, { title: 'Ivan Magalhaes', image: 'ivanmagalhaes.png', desc: 'How to write content about your photographs?', time: '3 hrs ago' },
      { title: 'Brad Joe', image: 'amyelsner.png', desc: 'Start a blog to reach your creative peak.', time: '4 hrs ago' },
      { title: 'Alison Perez', image: 'bernardodominic.png', desc: 'Starting your traveling blog with Vasco.', time: '5 hrs ago' },
      { title: 'Barry Mass', image: 'ionibowcher.png', desc: 'How to write content about your photographs?', time: '6 hrs ago' },
      { title: 'Ronnie Mass', image: 'bernardodominic.png', desc: 'Start a blog to reach your creative peak.', time: '7 hrs ago' }
    ];

    ngOnInit() {
      this.environmentName = localStorage.getItem('environmentName') || '';
    }

    // ngOnInit() {


    //   this.items = [
    //     {
    //       label: 'Actions',
    //       items: [
    //         {
    //           label: 'Profile Settings',
    //           icon: 'pi pi-user',
    //           command: () => {
    //             this.showProfile = true;
    //           }
    //         },
    //         {
    //           label: 'Help',
    //           icon: 'pi pi-question-circle'
    //         },
    //         {
    //           label: 'Logout',
    //           icon: 'pi pi-power-off',
    //           command: () => {
    //             this.handleLogout();
    //           }
    //         }

    //       ]
    //     }
    //   ];

    //   this.userProfileName = this.localStorage.getProfileName();
    //   this.selectedCampus = this.localStorage.getCampusId();
    //   if(this.localStorage.getProfilePicture() != 'null'){
    //     this.profilePicture = this.localStorage.getProfilePicture();
    //   }

    //   this.environmentName = localStorage.getItem('environmentName') || '';

    //   console.log("profilepic",this.profilePicture)

    // }


    // onCampusChange(event: any) {
    //   console.log(event)
    //   this.localStorage.setCampusId(event.value);
    //   // reload the page
    //   window.location.reload();
    // }


    handleLogout() {
      console.log('logout')
    this.auth.logOut();

      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Logged out successfully' });
      this.router.navigate(['login'])
    }

  handleCloseProfile() {
      this.showProfile = false;
    }

  getInitials(): string {
      let name = this.localStorage.getProfileName() || '';
      let initials = name.split(' ').map((n: string) => n[0]).join('').toUpperCase();
      return initials.length > 2 ? initials.substring(0, 2) : initials;
    }

}
